export default __webpack_public_path__ + "static/ios14-safe-area-inset-bottom-75737807d200030baddaa5fa038f31ce.mp4";